import { Stack, Text } from '@chakra-ui/react';
import type { SanityImage } from '@time-line/components/types';
import { useImage } from 'lib/sanity';
import Img from 'next/image';

interface ImageWithCaptionProps {
  image: SanityImage;
  caption?: string;
}

export function ImageWithCaption({ image, caption }: ImageWithCaptionProps) {
  const imageProps = useImage(image);

  return (
    <Stack spacing="4xs" className="media">
      {imageProps && (
        <Img
          {...imageProps}
          className="round"
          sizes="(min-width: 1920px) 1040px, (min-width: 768px) 50vw, 90vw"
        />
      )}
      {caption && (
        <Text color="blackAlpha.700" size="detail">
          {caption}
        </Text>
      )}
    </Stack>
  );
}
